import React from 'react';
import './Footer.css';

const Footer = ({ handleContactClick }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section about-section">
          <h3>Being Volunteer USA</h3>
          <p>
            Empowering individuals through meaningful volunteer experiences and community engagement. Together, we build a nation where everyone works together to create a better world.
          </p>
          <a
            href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=GMVXR9RS2FD84"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-donate-button"
          >
            Donate Now
          </a>
        </div>

        <div className="footer-section links-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/#home">Home</a></li>
            <li><a href="/#about">About Us</a></li>
            <li><a href="/#what-we-do">What We Do</a></li>
            <li><a href="/#media">Media Gallery</a></li>
            <li><a href="/#projects">Our Projects</a></li>
            <li>
              <button onClick={handleContactClick} className="footer-link-button">
                Contact Us
              </button>
            </li>
          </ul>
        </div>

        <div className="footer-section contact-section">
          <h3>Get Involved</h3>
          <p>Join us in making a difference in our community. Every contribution matters.</p>
          <div className="social-links">
            <a href="https://www.facebook.com/BeingVolunteerUSA/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
          </div>
          <p className="footer-email">
            Queries? Mail us: <a href="mailto:contact@beingvolunteerusa.org">contact@beingvolunteerusa.org</a>
          </p>
          <button onClick={handleContactClick} className="footer-contact-button">
            Get In Touch
          </button>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Being Volunteer USA. All rights reserved. | <strong>IRS EIN: 823181706</strong></p>
      </div>
    </footer>
  );
};

export default Footer;
